import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../components/controls/Button";
import SuccessImg from "../../../images/AnanasSolutionsLogo.webp";

export default function StorePaymentSuccess() {
  const [searchParams] = useSearchParams();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const lang = searchParams.get("lang") || "fr";
    i18n.changeLanguage(lang);
  }, [searchParams]);

  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-b from-[#fff8e8] to-white">
      <section className="w-full max-w-lg text-center">
        {/* Halo doux */}
        <div className="relative mx-auto w-48 sm:w-44 aspect-square">
          <div className="absolute inset-0 rounded-full bg-[#ffefc2] blur-3xl opacity-60" />
          <img
            src={SuccessImg}
            alt={t("payment.successImageAlt", "Logo Ananas Solutions")}
            className="relative z-10 w-full h-full object-contain drop-shadow-md"
          />
        </div>

        {/* Nouveau titre premium */}
        <h1 className="mt-8 text-3xl font-semibold text-[#2f5130]">
          {t("payment.successTitle", "Merci pour votre achat")}
        </h1>

        {/* Paragraphe chaleureux */}
        <p className="mt-4 text-base leading-relaxed text-[#6b705c]">
          {t(
            "payment.successMessage",
            "Votre paiement a été traité avec succès."
          )}
        </p>

        <p className="mt-2 text-sm text-[#8a8f89]">
          {t(
            "payment.successSupport",
            "Merci de soutenir les entreprises locales. Votre geste fait une réelle différence."
          )}
        </p>

        <p className="mt-4 text-xs opacity-70">
          {t(
            "payment.successFollowup",
            "Un courriel de confirmation vous sera envoyé sous peu."
          )}
        </p>

        {/* Boutons */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            as="a"
            size="lg"
            href={`/store/orders?lang=${searchParams.get("lang") || "fr"}`}
            fullWidth
            className="sm:w-auto shadow-md hover:shadow-lg transition-all hidden"
          >
            {t("payment.viewOrder", "Voir ma commande")}
          </Button>

          <Button
            as="a"
            size="lg"
            href={`/boutique?lang=${searchParams.get("lang") || "fr"}`}
            fullWidth
            className="sm:w-auto shadow-md hover:shadow-lg transition-all"
          >
            {t("payment.returnToStore", "Retour à la boutique")}
          </Button>
        </div>
      </section>
    </main>
  );
}
